// extracted by mini-css-extract-plugin
module.exports = {"pe":"Intro_pe__2lCpV","intro":"Intro_intro__eTriH"};